// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-group-id-section{

}

.search-group-id-section .search-group{
    display: flex;
    align-items: center;
}

.search-group-id-section .search-group .search-field{
    display: flex;
    align-items: center;
    background-color: white;
    border: 1px solid #EEE;
    border-radius: 22px;
    padding: 8px 22px;
    width: 289px;
    max-width: 100%;
}

.search-group-id-section .search-group .search-field svg{
    color: var(--gray-color);
    font-size: 16px;
}

.search-group-id-section .search-group .search-field input {
    width: 276px;
    border: none;
    font-size: 13px;
    margin-left: 8px;
}

.search-group-id-section .search-group .search-field input:focus{
    outline: none;
}

.search-group-id-section .search-group .get-group-btn
{
    background-color: var(--main-color);
    color: white;
    padding: 8px 22px ;
    width: 115px;
    margin: 0px 7px;
    border: none;
    border-radius: 22px;
    transition: var(--main-transition);
    font-weight: bold;
    cursor: pointer;
}

.search-group-id-section .search-group .get-group-btn:hover{
    background-color:#5783db ;
}

.search-group-id-section .all-posts{
    margin-top: 14px;
}

`, "",{"version":3,"sources":["webpack://./src/Pages/SpecificGroup/specificGroup.css"],"names":[],"mappings":"AAAA;;AAEA;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,mCAAmC;IACnC,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,kCAAkC;IAClC,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".search-group-id-section{\n\n}\n\n.search-group-id-section .search-group{\n    display: flex;\n    align-items: center;\n}\n\n.search-group-id-section .search-group .search-field{\n    display: flex;\n    align-items: center;\n    background-color: white;\n    border: 1px solid #EEE;\n    border-radius: 22px;\n    padding: 8px 22px;\n    width: 289px;\n    max-width: 100%;\n}\n\n.search-group-id-section .search-group .search-field svg{\n    color: var(--gray-color);\n    font-size: 16px;\n}\n\n.search-group-id-section .search-group .search-field input {\n    width: 276px;\n    border: none;\n    font-size: 13px;\n    margin-left: 8px;\n}\n\n.search-group-id-section .search-group .search-field input:focus{\n    outline: none;\n}\n\n.search-group-id-section .search-group .get-group-btn\n{\n    background-color: var(--main-color);\n    color: white;\n    padding: 8px 22px ;\n    width: 115px;\n    margin: 0px 7px;\n    border: none;\n    border-radius: 22px;\n    transition: var(--main-transition);\n    font-weight: bold;\n    cursor: pointer;\n}\n\n.search-group-id-section .search-group .get-group-btn:hover{\n    background-color:#5783db ;\n}\n\n.search-group-id-section .all-posts{\n    margin-top: 14px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
